export default __webpack_public_path__ + "img/fGaSGCFJ.64512e06.svg";